// Updated About.js
import ProfileCard from './ProfileCard';
import p_pic from "./profile.png";
import { useNavigate } from 'react-router-dom';
import './About.css';  // Import the new CSS file

const About = () => {
  const navigate = useNavigate();

  return (
    <div className="about-page">
      <h1>About Me</h1>

      {/* Hero Bio Card */}
      <div className="hero-bio">
        <ProfileCard
          name=""
          title=""
          handle="Hazimmalik"
          status="Available for Opportunities"
          contactText="Get In Touch"
          avatarUrl={p_pic}
          showUserInfo={true}
          enableTilt={true}
          enableMobileTilt={true}
          onContactClick={() => navigate('/contact')}  
          showIcon={true}
          behindGlow={true}
          behindGlowColor="rgba(56, 189, 248, 0.6)"
        />

        <div className="bio-text">
          <p>
            I am Muhammad Hazim (professionally known as Hazim Malik), a Machine Learning Engineer and Research Assistant specializing in Graph Neural Networks, privacy-preserving ML, and secure AI systems. 
            I build high-accuracy, production-ready models for real-world challenges in IoT security, healthcare diagnostics, and predictive robotics.
          </p>

          {/* Added Download Resume button */}
          <div style={{ marginTop: '1.5rem' }}>
            <a
              href="/Hazim_Malik_Resume.pdf"
              download="Hazim_Malik_Resume.pdf"
              style={{
                textDecoration: 'none'
              }}
            >
              <button
                style={{
                  backgroundColor: "var(--accent)",
                  color: "#FFFFFF",
                  padding: "12px 28px",
                  border: "none",
                  borderRadius: "12px",
                  fontSize: "1.1rem",
                  cursor: "pointer",
                  fontWeight: 600,
                }}
              >
                Download Resume
              </button>
            </a>
          </div>
        </div>
      </div>

      {/* Experience Section */}
      <section className="experience-section">
        <h2>Experience</h2>
        <div className="experience-grid">
          {[
            { role: "Machine Learning Research Assistant", company: "City University of Science and Information Technology", period: "September 2023 – Present", location: "Peshawar, Pakistan", description: "Researching Graph Neural Networks for privacy-preserving ML applications." },
            { role: "Machine Learning Intern", company: "National Center for Artificial Intelligence", period: "July 2023 – September 2023", location: "Peshawar, Pakistan", description: "Developed ensemble models for IoT intrusion detection." },
            { role: "Machine Learning Intern", company: "CodeAlpha", period: "July 2024 – August 2024", location: "Remote", description: "Developed a comprehensive movie recommendation system using collaborative filtering and content-based techniques." },
            { role: "Machine Learning Intern", company: "Bytewise Limited", period: "June 2024 – July 2024", location: "Remote", description: "Worked on deep learning projects, including image classification using CNNs and transfer learning with pre-trained models like ResNet and VGG." },
          ].map((exp, i) => (
            <div key={i} className="experience-card">
              <h3>{exp.role}</h3>
              <p>
                {exp.company} • {exp.period} • {exp.location}
              </p>
              <p>{exp.description}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Skills Section */}
      <section className="skills-section">
        <h2>Skills</h2>
        <div className="skills-container">
          {[
            { category: "Machine Learning Frameworks", skills: ["PyTorch", "TensorFlow", "Scikit-learn", "Keras"] },
            { category: "Programming Languages", skills: ["Python", "C++", "JavaScript", "SQL"] },
            { category: "Data Processing & Visualization", skills: ["NumPy", "Pandas", "Matplotlib", "Seaborn"] },
            { category: "Tools & Platforms", skills: ["Git", "Docker", "Kubernetes", "AWS", "Google Colab"] },
            { category: "Other", skills: ["Graph Neural Networks", "Computer Vision", "NLP", "Ensemble Learning"] }
          ].map((skillGroup, i) => (
            <div key={i} className="skill-group">
              <h3>{skillGroup.category}</h3>
              <div className="skills-tags">
                {skillGroup.skills.map(skill => (
                  <span key={skill} className="skill-tag">
                    {skill}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Education Section */}
      <section className="education-section">
        <h2>Education</h2>
        <div className="education-list">
          {[
            { degree: "BS Computer Science", school: "City University of Science and Information Technology", period: "September 2020 – July 2024", location: "Peshawar, Pakistan", modules: ["Computer Vision", "Artificial Intelligence", "Data Structures & Algorithms", "Design and Analysis of Algorithms", "Parallel and Distributed Computing", "Mobile Development & Information Security"] },
            { degree: "Higher Secondary School Certificate (12th)", school: "Government College Peshawar", period: "April 2018 – October 2019", location: "Peshawar, Pakistan", modules: ["Physics", "Computer", "Mathematics"] },
            { degree: "Secondary School Certificate (10th)", school: "Jamal English Education Academy", period: "March 2004 – May 2017", location: "Pabbi, Pakistan", modules: ["Physics", "Chemistry", "Mathematics", "Computer Science"] }
          ].map((edu, i) => (
            <div key={i} className="education-card">
              <h3>{edu.degree}</h3>
              <p>
                {edu.school} • {edu.period} • {edu.location}
              </p>
              <strong>Key Modules:</strong>
              <div className="modules-tags">
                {edu.modules.map(m => (
                  <span key={m} className="module-tag">
                    {m}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default About;
